import React, { useState } from "react";
import { Link } from "react-router-dom";
import Icons from "../Helpers/Icons";
import SelectBox from "../Helpers/SelectBox";

export default function RightSideBar() {
  const filterDatas = ["Last 15 days", "Last Month", "Last 6 month"];
  const [filterDataSet, setFilterDataSet] = useState([10, 30, 20, 40]);
  const dataSetHandler = (value) => {
    if (value === "Last 15 days") {
      setFilterDataSet([10, 30, 20, 40]);
    } else if (value === "Last Month") {
      setFilterDataSet([15, 35, 10, 20]);
    } else {
      setFilterDataSet([8, 15, 40, 30]);
    }
  };

  return (
    <>
      <div className="right-sidebar-wrapper overflow-y-scroll overflow-style-none 2xl:fixed 2xl:grid-cols-none 2xl:block grid lg:grid-cols-2 grid-cols-1 xl:gap-7 gap-4 h-full 2xl:pb-96">
        <div className="top-platform bg-white dark:bg-dark-white   rounded-2xl p-8 2xl:w-[268px] w-full 2xl:mb-10 2xl:border-none  border ">
          {/* heading */}
          <div className="heading flex justify-between items-center mb-3.5">
            <h3 className="text-xl font-bold   text-dark-gray dark:text-white">
              Quick Links
            </h3>
            <div></div>
          </div>

          <div className="platform-list flex flex-col gap-4">
            <Link
              to="/alerts"
              className="cursor-pointer p-2 md:hover:shadow-md transition md:hover:duration-300 rounded-md"
            >
              <div className="item flex space-x-3 items-center">
                <span className="item-icon group-hover:bg-purple group-hover:text-white w-8 h-8 flex justify-center items-center transition-all duration-300 ease-in-out  bg-light-purple dark:bg-dark-light-purple rounded-full">
                  <Icons name="reminder" />
                </span>
                <p className="text-thin-light-gray text-base font-medium">
                  View Alerts
                </p>

                {/* action */}
              </div>
            </Link>
            <Link
              to="/#"
              className="cursor-pointer p-2 md:hover:shadow-md transition md:hover:duration-300 rounded-md"
            >
              <div className="item flex space-x-3 items-center">
                <span className="item-icon group-hover:bg-purple group-hover:text-white w-8 h-8 flex justify-center items-center transition-all duration-300 ease-in-out  bg-light-purple dark:bg-dark-light-purple rounded-full">
                  <Icons name="tracking2" />
                </span>
                <p className="text-thin-light-gray text-base font-medium">
                  Add Tracking
                </p>
                {/* action */}
              </div>
            </Link>
          </div>
        </div>

        {/* top-platform */}
      </div>
    </>
  );
}
